import React from 'react';
import PropTypes from 'prop-types';
import CustomNewConfirm from 'components/NewDesign/CustomNewConfirm';
import CustomDropdown from 'components/NewDesign/CustomDropdown/CustomDropdown';
import { CSV_FORMAT_OPTIONS } from 'constants';
import styles from './ExportFormatDialog.module.css';

// The Export dialog of Event View and the Season Best Report: one choice, the
// file's format, ResultsHQ Excel or SplitFast csv, by the same names on both
// (Doug, 2026-10-25). The page exports what its filters show. Under the box, one
// line says what the chosen format is. Export is the stronger blue (primary2):
// the light "info" blue beside the grey Cancel looked disabled (Doug, 2026-10-25).
const ExportFormatDialog = ({ isOpen, format, onFormatChange, onExport, onClose }) => {
  const chosen = CSV_FORMAT_OPTIONS.find((option) => option.value === format);
  return (
    <CustomNewConfirm
      isOpen={isOpen}
      title="Export to file"
      confirmButtonText="Export"
      confirmButtonVariant="primary2"
      onConfirm={onExport}
      onClose={onClose}
    >
      <div className={styles.format}>
        <CustomDropdown
          label="Format"
          name="format"
          value={format}
          options={CSV_FORMAT_OPTIONS}
          onChange={(name, value) => onFormatChange(value)}
        />
        {chosen?.description && <div className={styles.helpText}>{chosen.description}</div>}
      </div>
    </CustomNewConfirm>
  );
};

ExportFormatDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  // A value of CSV_FORMAT_OPTIONS: 'rhq_excel' or 'sf_csv'.
  format: PropTypes.string.isRequired,
  onFormatChange: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ExportFormatDialog;
